import { URL } from '@api/urls';

import { ECrowdCellConnectionType } from '@enums/common';

import { routes } from '@constants/routes';

export const filterWidth = '200px';

export const linkTooltipContent = 'Link the site';
export const unlinkTooltipContent = 'Unlink the site';

export const entityOptions = [
	{
		label: 'Yes',
		value: true,
	},
	{
		label: 'No',
		value: false,
	},
];

export const statusOptions = [
	{
		label: 'Online',
		value: ECrowdCellConnectionType.ONLINE,
	},
	{
		label: 'Offline',
		value: ECrowdCellConnectionType.OFFLINE,
	},
];

export const linkedOptions = [
	{
		label: 'Show linked cells',
		value: true,
	},
	{
		label: 'Show unlinked cells',
		value: false,
	},
];

export const linkActions = [
	{
		label: 'Link to site',
		name: 'exist',
	},
	{
		label: 'Add new site and link to it',
		name: 'add',
	},
];

export const { adminPanel: { index, manageSite } } = routes;

export const { siteProfile } = URL;
